var _mask, _path, _mask2, _path2, _mask3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 659,
    viewBox: "0 0 216 659",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_982_550",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.514 163.516C121.617 163.516 79.5179 180.954 48.478 211.994C17.4381 243.034 3.31414e-06 285.133 0 329.03C-3.31414e-06 372.927 17.438 415.026 48.478 446.066C79.5179 477.106 121.617 494.544 165.514 494.544L165.514 329.03L165.514 163.516Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.514 163.516C121.617 163.516 79.5179 180.954 48.478 211.994C17.4381 243.034 3.31414e-06 285.133 0 329.03C-3.31414e-06 372.927 17.438 415.026 48.478 446.066C79.5179 477.106 121.617 494.544 165.514 494.544L165.514 329.03L165.514 163.516Z",
    stroke: "#FF3740",
    strokeWidth: 4.42,
    mask: "url(#path-1-inside-1_982_550)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_982_550",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.489 165.618C495.489 121.721 478.051 79.6214 447.011 48.5815C415.971 17.5416 373.872 0.103546 329.975 0.103546C286.078 0.103546 243.979 17.5416 212.939 48.5815C181.899 79.6214 164.461 121.721 164.461 165.618L329.975 165.618L495.489 165.618Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M495.489 165.618C495.489 121.721 478.051 79.6214 447.011 48.5815C415.971 17.5416 373.872 0.103546 329.975 0.103546C286.078 0.103546 243.979 17.5416 212.939 48.5815C181.899 79.6214 164.461 121.721 164.461 165.618L329.975 165.618L495.489 165.618Z",
    stroke: "#A5A5A5",
    strokeWidth: 4.42,
    mask: "url(#path-2-inside-2_982_550)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_982_550",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.461 493.486C164.461 537.383 181.899 579.482 212.939 610.522C243.979 641.562 286.078 659 329.975 659C373.872 659 415.971 641.562 447.011 610.522C478.051 579.482 495.489 537.383 495.489 493.486L329.975 493.486H164.461Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.461 493.486C164.461 537.383 181.899 579.482 212.939 610.522C243.979 641.562 286.078 659 329.975 659C373.872 659 415.971 641.562 447.011 610.522C478.051 579.482 495.489 537.383 495.489 493.486L329.975 493.486H164.461Z",
    stroke: "#17A1FA",
    strokeWidth: 4.42,
    mask: "url(#path-3-inside-3_982_550)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern3);
export default __webpack_public_path__ + "static/media/pattern3.a74b21ce84ee946450fe17a7d656e34d.svg";
export { ForwardRef as ReactComponent };